import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { confirmAlert, generalAlertError } from '../../common/utils/alerts';
import { EstimateContainer } from '../../common/components/redesignComponents/common/Redesign.styles';
import ErrorComponent from '../../common/components/ErrorComponent';
import {
  addPublicEmploymentQuoteToCart,
  publicEmploymentQuotesGetQuotes,
  removePublicEmploymentQuoteFromCart,
} from '../../features/insuranceRequests/insuranceRequestsActions';
import PubblicoImpiegoModalButtons from './components/PubblicoImpiegoModalButtons';
import PubblicoImpiegoModal from './components/PubblicoImpiegoModal';
import { PubblicoImpiegoQuotesStyles, RiskContainer } from './styles/PubblicoImpiegoResultPage.styles';
import PageLoading from '../../common/componentsV2/elements/PageLoading';
import ConversationModal from '../../common/components/redesignComponents/Modal/ConversationModal';
import { primaQuoteTypes } from '../../common/constants';
import { V2FontImport } from '../../common/formInputsV2/V2Fonts';
import ResultOverviewRow from '../../common/components/redesignComponents/ResultPageComponents/v2/ResultOverviewRow';
import PubblicoImpiegoSummaryCard from '../../common/components/redesignComponents/ResultPageComponents/v2/PubblicoImpiegoSummaryCard';
import QuoteCostSummaryCard from '../../common/components/redesignComponents/ResultPageComponents/v2/QuoteCostSummaryCard';
import {
  OutlineActionButton,
  ActionButtonBadge,
} from '../../common/components/redesignComponents/ResultPageComponents/v2/SecondaryActionButtons.styles';
import { ChatIcon } from '../../common/components/redesignComponents/ResultPageComponents/v2/ActionIcons';

function PubblicoImpiegoResultPage() {
  const { requestToken } = useParams();
  const navigate = useNavigate();
  const {
    loading,
    error,
    insuranceRequest,
    customer,
    quotations,
    addingQuote,
    processingQuote,
    riskQuotations,
    // toSelect,
    quote_id_to_add,
    thread,
    est_provvigioni,
  } = useSelector((store) => store.insuranceRequests.public_employment);
  const [showConversationModal, setShowConversationModal] = useState(false);
  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);

  // const [showModal, setShowModal] = useState(false);
  const refresh = () => publicEmploymentQuotesGetQuotes(requestToken);
  const silentRefresh = () => publicEmploymentQuotesGetQuotes(requestToken);

  const modifyData = () => {
    navigate('/quote/pubblico-impiego', {
      state: { requestToken },
    });
  };

  const selectQuotation = (quoteId, closeButton) => {
    confirmAlert('Sei Sicuro di aggiungere questa quotazione?', () => addPublicEmploymentQuoteToCart(
      quoteId,
      refresh,
      modifyData,
      closeButton,
      quote_id_to_add,
    ));
  };

  const removeItemFromCart = (quoteId) => {
    confirmAlert('Sei Sicuro di rimuovere questa quotazione?', () => removePublicEmploymentQuoteFromCart(quoteId, refresh, modifyData));
  };

  useEffect(() => {
    publicEmploymentQuotesGetQuotes(requestToken);
  }, [requestToken]);

  const handleRequestPurchase = () => {
    if (processingQuote === null) {
      generalAlertError('Seleziona Prima La Responsabilita Civile', 'Errore');
      return;
    }

    navigate(`/quotes/pubblico-impiego/purchase/${requestToken}`);
  };

  const getTotal = () => {
    let quoteInProccessAmount = 0;
    let risksTotalAmount = 0;

    if (processingQuote !== null && processingQuote.amount !== null) {
      quoteInProccessAmount = parseFloat(processingQuote.amount);
    }

    const riskTypes = quoteTypes.filter((t) => t.id !== 'res_civile');

    for (let x = 0; x < riskTypes.length; x++) {
      const type = riskTypes[x];
      if (riskQuotations && riskQuotations[type.id] !== undefined) {
        for (let i = 0; i < riskQuotations[type.id].length; i++) {
          const item = riskQuotations[type.id][i];

          risksTotalAmount += parseFloat(item.amount);
        }
      }
    }

    return (quoteInProccessAmount + risksTotalAmount).toFixed(2);
  };

  // useEffect(() => {
  //   if (loading === false && insuranceRequest.is_expired === true && insuranceRequest.request_token === requestToken) {
  //     navigate('/quote/pubblico-impiego', {
  //       state: { requestToken: insuranceRequest.request_token },
  //     });
  //     generalAlertError(
  //       'È necessario compilare nuovamente il preventivo!',
  //       'Link e scaduto!',
  //     );
  //   }
  // }, [loading, insuranceRequest, requestToken]);

  if (loading) {
    return <PageLoading />;
  }

  if (error !== null) {
    return <ErrorComponent error={error} />;
  }

  return (
    <>
      {showConversationModal && (
        <ConversationModal
          requestId={insuranceRequest?.id}
          threadId={thread?.thread_id}
          onClose={() => {
            setShowConversationModal(false);
            silentRefresh();
          }}
          onUpdated={() => silentRefresh()}
          location="quotation_pubblico_impiego_result"
        />
      )}
      <V2FontImport />
      <PubblicoImpiegoQuotesStyles>
        <div className="resultsPage">
          <ResultOverviewRow>
            <PubblicoImpiegoSummaryCard
              customer={customer}
              insuranceRequest={insuranceRequest}
              modifyData={modifyData}
            />
            <QuoteCostSummaryCard
              processingQuote={processingQuote}
              quoteTypes={quoteTypes}
              riskQuotations={riskQuotations}
              primaQuoteTypes={primaQuoteTypes}
              getTotal={getTotal}
              onProcedi={() => handleRequestPurchase()}
              rcTypeLabel={processingQuote?.product_name}
              est_provvigioni={est_provvigioni}
            />
          </ResultOverviewRow>
          <div className="row">
            <div className="col-12 ">
              <EstimateContainer>
                <div className="d-flex gap-2 justify-content-end ">
                  <div>
                    {/* {localStorage.getItem('quoteNewResult') === 'done' && (
                      <div style={{ cursor: 'pointer' }} onClick={() => firePurchaseTour()}>
                        <button className="btn btn-success px-2 py-1">Tutorial</button>
                      </div>
                    )} */}
                    <OutlineActionButton
                      type="button"
                      onClick={() => {
                        setShowConversationModal(true);
                        if (thread?.unreadMessages > 0) silentRefresh();
                      }}
                    >
                      <ChatIcon />
                      Contatta il Backoffice
                      {thread?.unreadMessages > 0 && (
                        <ActionButtonBadge>
                          {thread.unreadMessages}
                          <span className="visually-hidden">messaggi non letti</span>
                        </ActionButtonBadge>
                      )}
                    </OutlineActionButton>
                  </div>
                </div>
              </EstimateContainer>
            </div>
          </div>

          {quotations && quotations.res_civile
            && (
              <>
                <RiskContainer className="mb-3 pb-3 result-home-third-step">
                  {quoteTypes.map((type, index) => (
                    <React.Fragment key={index}>
                      {quotations && quotations[type.id] && (
                        <PubblicoImpiegoModalButtons
                          insuranceRequest={insuranceRequest}
                          processingQuote={processingQuote}
                          type={type}
                          removeItemFromCart={removeItemFromCart}
                          riskQuotations={riskQuotations}
                        />
                      )}
                    </React.Fragment>
                  ))}
                </RiskContainer>
                {quoteTypes.map((type, index) => (
                  <PubblicoImpiegoModal
                    insuranceRequest={insuranceRequest}
                    type={type}
                    key={index}
                    addingQuote={addingQuote}
                    quotations={quotations}
                    selectQuotation={selectQuotation}
                    processingQuote={processingQuote}
                  />
                ))}
              </>
            )}
        </div>

      </PubblicoImpiegoQuotesStyles>
    </>
  );
}

export default PubblicoImpiegoResultPage;
